import { ReactNode } from 'react';

import { Box } from '../../../common/ui/Box';
import { ClearFilters } from '../ClearFilters/ClearFilters';

interface BasicFilterContainerProps {
    children: ReactNode;
    hasActiveFilters: boolean;
    onClear: () => void;
}

export const BasicFilterContainer = ({ children, hasActiveFilters, onClear }: BasicFilterContainerProps) => {
    return (
        <Box display="flex" gap={8}>
            {children}
            {hasActiveFilters && <ClearFilters onClearClick={onClear} />}
        </Box>
    );
};
